<template>
  <metric-grid>
    <metric-card
      title="Unique domains AI used"
      info-title="Distinct websites AI relied on in its answers"
      :value="metrics.uniqueWebsites"
      :trend="uniqueWebsitesTrend"
    />
    <metric-card
      title="Unique URLs AI used"
      info-title="Individual pages AI pulled into its answers"
      :value="metrics.uniqueCitationUrls"
      :trend="uniqueCitationUrlsTrend"
    />
    <metric-card
      title="Total sources AI used"
      info-title="Total citations across all AI answers"
      :value="metrics.totalCitations"
      :trend="totalCitationsTrend"
    />
    <metric-card
      title="High-Opportunity Sources"
      info-title="Pages where you're missing but competitors aren't"
      :value="metrics.highOpportunitySources"
      :trend="highOpportunitySourcesTrend"
      value-tone="negative"
      class="main-card"
    />
  </metric-grid>
</template>

<script>
import MetricGrid from '../../../ui/cards/MetricGrid.vue'
import MetricCard from '../../../ui/cards/MetricCard.vue'

export default {
  name: 'CitationMetrics',
  components: {
    MetricGrid,
    MetricCard
  },
  props: {
    metrics: {
      type: Object,
      required: true,
    },
  },
  computed: {
    metricTrends () {
      return this.metrics?.trends || {}
    },
    uniqueWebsitesTrend () {
      return this.buildTrend(
        this.metricTrends.uniqueWebsites,
        (value) => `${this.formatSignedValue(value)} this week`,
      )
    },
    uniqueCitationUrlsTrend () {
      return this.buildTrend(
        this.metricTrends.uniqueCitationUrls,
        (value) => `${this.formatSignedValue(value)} this week`,
      )
    },
    totalCitationsTrend () {
      return this.buildTrend(
        this.metricTrends.totalCitations,
        (value) => `${this.formatSignedValue(value)} this week`,
      )
    },
    highOpportunitySourcesTrend () {
      return this.buildTrend(
        this.metricTrends.highOpportunitySources,
        (value) => `${this.formatSignedValue(value)} this week`,
        true,
      )
    },
  },
  methods: {
    buildTrend (value, formatLabel, invertTone = false) {

      if (value === null) return null;

      const numericValue = Number(value || 0)

      if (!numericValue) {
        return {
          direction: 'flat',
          tone: 'neutral',
          label: 'No change',
        }
      }

      const isPositiveChange = numericValue > 0
      const isGoodChange = invertTone ? !isPositiveChange : isPositiveChange

      return {
        direction: isPositiveChange ? 'up' : 'down',
        tone: isGoodChange ? 'positive' : 'negative',
        label: formatLabel(numericValue),
      }
    },
    formatSignedValue (value) {
      return `${value > 0 ? '+' : ''}${value}`
    },
  },
}
</script>
